var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.5823,20.7923H1.521V7.7058H5.5823ZM3.5516,5.9459A2.35,2.35,0,0,1,1.2051,3.3286,2.3092,2.3092,0,0,1,3.2809,1.2528a2.3539,2.3539,0,1,1,.2707,4.6931ZM20.8349,20.7923H16.7735V14.4747c0-1.5343,0-3.4747-2.1209-3.4747s-2.4368,1.67-2.4368,3.3844v6.4531H8.1545V7.7509h3.8808v1.76H12.08A4.2281,4.2281,0,0,1,15.9161,7.39c4.1065,0,4.8736,2.6625,4.8736,6.2274l.0452,7.175Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.9a366cfe81a68d38e22818a42c1705a7.svg";
export { ForwardRef as ReactComponent };